// Simple event emitter for floor plan metadata updates
class FloorPlanMetadataEventEmitter extends EventTarget {
  emitUpdate(floorPlanId: string) {
    this.dispatchEvent(new CustomEvent('metadata-update', { detail: { floorPlanId } }));
  }
  
  onUpdate(callback: (event: CustomEvent) => void) {
    this.addEventListener('metadata-update', callback as EventListener);
    return () => this.removeEventListener('metadata-update', callback as EventListener);
  }
}

export const floorPlanMetadataEvents = new FloorPlanMetadataEventEmitter();